module.exports = __webpack_public_path__ + "img/Consultation1.389e8554.png";